import React, { FC, useContext, Fragment } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { NotFoundView } from 'views/Errors/NotFound.view';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';

import {
  ROUTE_OTHER_COMMUNE,
  ROUTE_REPORTS,
  ROUTE_REPORTS_AUDIT_LOG,
  ROUTE_STATISTIC,
  ROUTE_STATISTIC_DETAILS,
  ROUTE_SUBVENTION_FORECAST,
  ROUTE_SYNCHRONIZATIONS_REPORT,
  ROUTE_PERSONAL_DATA_ACCESS_LIST,
} from 'config/routes';
import { relativePath } from 'utils/navigation/relativePath';
import { LocaleContext } from 'context/locale';
import { LogsView } from 'views/Panel/Reports/Logs/Logs.view';
import { SchoolStatView } from 'views/Panel/Reports/SchoolStat/SchoolStat';
import { SchoolStatDetailsView } from 'views/Panel/Reports/SchoolStatDetails/SchoolStatDetails';
import { OtherCommuneView } from 'views/Panel/Reports/OtherCommune/OtherCommune.view';
import { SubventionForecastView } from 'views/Panel/Reports/SubventionForecast/SubventionForecast.view';
import { SynchronizationsReportView } from 'views/Panel/Reports/Synchronizations/Synchronizations.view';
import { AccessListContainer } from '../PersonalDataAccess/AccessListContainer';

export const ReportsView: FC = () => {
  const { trans } = useContext(LocaleContext);

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.REPORTS.REPORTS')} static />

      <Routes>
        <Route path={relativePath(ROUTE_REPORTS, ROUTE_REPORTS)} element={<Navigate to={ROUTE_REPORTS_AUDIT_LOG} replace />} />
        <Route path={relativePath(ROUTE_REPORTS_AUDIT_LOG, ROUTE_REPORTS)} element={<LogsView />} />
        <Route path={relativePath(ROUTE_STATISTIC, ROUTE_REPORTS)} element={<SchoolStatView />} />
        <Route path={relativePath(ROUTE_STATISTIC_DETAILS, ROUTE_REPORTS)} element={<SchoolStatDetailsView />} />
        <Route path={relativePath(ROUTE_OTHER_COMMUNE, ROUTE_REPORTS)} element={<OtherCommuneView />} />
        <Route path={relativePath(ROUTE_SUBVENTION_FORECAST, ROUTE_REPORTS)} element={<SubventionForecastView />} />
        <Route
          path={relativePath(ROUTE_SYNCHRONIZATIONS_REPORT, ROUTE_REPORTS)}
          element={<SynchronizationsReportView />}
        />
        <Route
          path={relativePath(ROUTE_PERSONAL_DATA_ACCESS_LIST, ROUTE_REPORTS)}
          element={<AccessListContainer />}
        />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
